<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" :style="containerStyle">
          <div class="modal-header">
            <slot name="header">
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
    props: [
      'containerStyle',
    ],
    data() {
      return {}
    },
    mounted() {
    },
    computed: {
    },
    methods: {
      close: function() {
        this.showModal = false;
        this.$emit('close');
      },
    },
    watch: {
      show: function (newVal,oldVal) {
        Vue.set(this, 'showModal', newVal);
      }
    }
}
</script>
<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }
  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    overflow-y: initial !important
  }
  .modal-container {
    width: 500px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    /*font-family: Helvetica, Arial, sans-serif;*/
    /*overflow-y: auto;*/
    /*max-height: calc(100vh - 100px);*/
  }
  .modal-header h3 {
    margin-top: 0;
    /*color: #42b983;*/
  }
  .modal-body {
    margin: 20px 0;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
  }
</style>
